import { render } from "./PactoLegalPage.vue?vue&type=template&id=d99ec090&scoped=true"
import script from "./PactoLegalPage.vue?vue&type=script&lang=js"
export * from "./PactoLegalPage.vue?vue&type=script&lang=js"

import "./PactoLegalPage.vue?vue&type=style&index=0&id=d99ec090&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99ec090"]])

export default __exports__